export enum OrderStatusEnum {
  Drafted = 1,
  WaitingCosignature = 2,
  InReview = 3,
  SentToPhysician = 4,
  Completed = 5,
  Cancelled = 6
}

export const OrderStatusOptions = [
{ id: 1, label: 'Drafted', inProgress: false, canBeEdited: true },
{ id: 2, label: 'Waiting Cosignature', inProgress: false, canBeEdited: false },
{ id: 3, label: 'In Review', inProgress: false, canBeEdited: false },
{ id: 4, label: 'Sent To Physician', inProgress: true, canBeEdited: false },
{ id: 5, label: 'Completed', inProgress: true, canBeEdited: false },
{ id: 6, label: 'Cancelled', inProgress: false, canBeEdited: false }
];
